import styled, { css } from 'styled-components';
import { color } from '@whitelabel/helpers/style/colors';
import { HeadingBlock, CardBlock, ContentBlock } from '@whitelabel/component-library';

export const StyledCardBlock = styled(CardBlock)`
  background: ${color('white')};
  border: 0;
`;

export const StyledHeadingBlock = styled(HeadingBlock)`
  ${({ headingTag }) =>
    headingTag === 'h3' &&
    css`
      margin-bottom: 0;
    `}
`;

export const StyledContentBlock = styled(ContentBlock)`
  .section-block > .container {
    padding: 0 !important;
  }
`;
